import { useState } from 'react';
import { Collapse } from 'reactstrap';
import IconButton from './basics/IconButton';
import {
  BlockIconSpan,
  RoundedGreyContainer,
} from './form-components/RoundedGreyContainer';

const ExpandableItemsList = ({ items, title, onToggle, formatItem }) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleIsOpen = () => {
    onToggle?.(!isOpen);
    setIsOpen(!isOpen);
  };

  return (
    <RoundedGreyContainer className="mt-2">
      <div>
        <IconButton
          color="link"
          size="sm"
          onClick={toggleIsOpen}
          disabled={!items.length}
        >
          {items.length > 0 && (
            <BlockIconSpan>{isOpen ? `▾` : `▸`}</BlockIconSpan>
          )}
          {title}
        </IconButton>
        <Collapse isOpen={isOpen}>
          <ul className="mx-4 mb-3 px-1">
            {items.map((item) => (
              <li key={item.id}>{formatItem(item)}</li>
            ))}
          </ul>
        </Collapse>
      </div>
    </RoundedGreyContainer>
  );
};

export default ExpandableItemsList;
